import { Box, Link, Typography } from "@mui/material";

export default function MaintenancePage() {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 3,
        bgcolor: "#f5f5f5",
      }}
    >
      <Box sx={{ maxWidth: 480, textAlign: "center" }}>
        <Typography
          component="h1"
          variant="h5"
          sx={{ color: "text.primary", fontWeight: 600 }}
        >
          App under maintenance, apologies for inconvenience!
        </Typography>
        <Typography
          component="p"
          variant="body1"
          sx={{ mt: 2, color: "text.secondary" }}
        >
          Kindly WhatsApp your Order on <br/>
          <Link
            href="https://wa.me/918378909909"
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
          >
            8378-909-909
          </Link>
          
        </Typography>
      </Box>
    </Box>
  );
}
